import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { FundingJournalData } from '@/types/admin/funding';
import { getFundingAmounts, formatAmountDisplay, MEMO_LEDGER, MEMO_FEE, MEMO_TOTAL } from '@/utils/admin/fundingUtils';
import { ADMIN_COLORS } from '@/constants/admin';

export const JournalEntryCell: React.FC<{
  journalData: FundingJournalData | null;
  memos: string[];
}> = ({ journalData, memos }) => {
  const amounts = getFundingAmounts(journalData);
  let displayAmounts = { debitAmount: 0, creditAmount: 0 };

  if (memos.some(m => (MEMO_LEDGER as readonly string[]).includes(m))) {
    displayAmounts = amounts.ledger;
  } else if (memos.some(m => (MEMO_FEE as readonly string[]).includes(m))) {
    displayAmounts = amounts.fee;
  } else if (memos.some(m => (MEMO_TOTAL as readonly string[]).includes(m))) {
    displayAmounts = amounts.total;
  }

  const display = formatAmountDisplay(displayAmounts.debitAmount, displayAmounts.creditAmount);

  const getColor = () => {
    switch (display.color) {
      case 'green': return ADMIN_COLORS.SUCCESS;
      case 'red': return ADMIN_COLORS.ERROR;
      default: return ADMIN_COLORS.TEXT_TERTIARY;
    }
  };

  return (
    <View style={styles.journalCell}>
      <Text style={[styles.journalText, { color: getColor() }]}>
        {display.text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  journalCell: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    minHeight: 20,
  },
  journalText: {
    fontSize: 12,
    fontWeight: '500',
    textAlign: 'right',
  },
});


